import CrudStoreBuilder from "../common/CrudStoreBuilder";
import centerService from "@/services/salles/CenterService";

const getters = {
  getCenterGroups: (state) => {
    return Array.from(
      new Map(
        state.centers.map((item) => [item.centerGroupName, item])
      ).values()
    );
  },

  getCentersByCenterGroupId: (state) => (centerGroupId) => {
    return state.centers.filter(
      (center) => center.centerGroupId === centerGroupId
    );
  },
};

const actions = {
  /**
   * Produces a center object including its associated location properties
   * @param rawCenter Center object retrieved by the api
   * @returns Center object with location properties
   */
  async loadCenter({ rootGetters }, rawCenter) {
    const location = rootGetters["locationModule/getLocationById"](
      rawCenter.locationId
    );
    return {
      id: rawCenter.id,
      locationId: rawCenter.locationId,
      centerGroupId: rawCenter.centerGroupDto?.id,
      centerGroupName: rawCenter.centerGroupDto?.name,
      name: rawCenter.name,
      address: location ? location.address : "ville masqué",
      city: location ? location.city : "ville masqué",
      color: location ? location.color : "ville masqué",
      zipCode: location ? location.zipCode : "ville masqué",
      imageBase64: rawCenter.imageBase64,
      phoneNumber: rawCenter.phoneNumber,
      partialCap: rawCenter.partialCap,
      version: rawCenter.version,
    };
  },
};

export default new CrudStoreBuilder()
  .setName("center")
  .setService(centerService)
  .setDependents(["location"])
  .includeGetters(getters)
  .includeActions(actions)
  .build();
